<div class="auth-loader">
    <h2>Please Wait...</h2>
    <loading [cover]="false"></loading>
</div>